import { render, staticRenderFns } from "./EcommerceCardSix.vue?vue&type=template&id=1ba3bea6"
import script from "./EcommerceCardSix.vue?vue&type=script&lang=js"
export * from "./EcommerceCardSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports